export const defaultConfirmationPaneCancelButtonStyles = {
  backgroundColor: "white",
  fontFamily: "Segoe UI, Arial, sans-serif",
  fontSize: "14px",
  fontWeight: "500",
  height: "32px",
  width: "80px"
};